import React, { useState } from 'react';
import { Router } from '@reach/router';

import HomePage from './pages/home';
import MapExplorer from './pages/map-explorer';
import About from './pages/about';
import ComingSoon from './pages/coming-soon';
import Analysis from './pages/analysis';
import Tables from './pages/tables';
import Charts from './pages/charts';
import Charts2 from './pages/charts2';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './components/Login';
import Register from './components/SignUp';
import UserContext from './UserContext';


const App: React.FC = () => {
    const [user, setUser] = useState(localStorage.getItem('malaysia-persistedUser'));

    const userContext = {
        user,
        setUser
    };

    React.useEffect(() => {
        if (user) {
            localStorage.setItem('malaysia-persistedUser', user);
        } else {
            localStorage.removeItem('malaysia-persistedUser')
        }
    }, [user]);

  return (
  <UserContext.Provider value={userContext}>
    <Router>
      <HomePage path="/" />
      <About path="/about" />
      <Login path="/login" />
      <Register path="/register" />
      <ComingSoon path="/coming-soon" />
      <ProtectedRoute as={MapExplorer} path="/map-explorer" />
      <ProtectedRoute as={Analysis} path="/analysis" />
      <ProtectedRoute as={Tables} path="/tables" />
      <ProtectedRoute as={Charts2} path="/charts" />
      <ProtectedRoute as={Charts2} path="/charts2" />
    </Router>
  </UserContext.Provider>
  );
};

export default App;
